export { default as ShopFooter } from "./ShopFooter"
